/* unplugin-vue-components disabled */import script from "./NotificationTabbarItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationTabbarItem.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__